import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { brandName, heroImage, price, regularPrice, included } from '../data/copy';
import { optimizedImage, optimizedSrcSet } from '../utils/image';
export function OfferSection() {
  return <section id="offer" className="defer-paint w-full scroll-mt-6 bg-ink py-10 sm:py-14" aria-labelledby="offer-heading" data-id="element-136" data-mp="dex3wkczuwdp">
      <div className="mx-auto max-w-6xl px-6" data-id="element-137" data-mp="icymz5af6vp6">
        <div className="mx-auto mb-8 max-w-xl" data-id="element-138" data-mp="meabt8lgzcwb">
          <CountdownTimer data-id="element-139" data-mp="md0eilmfy8qq" />
        </div>

        <div className="mx-auto max-w-xl" data-id="element-140" data-mp="re696oznw62w">
          <div className="min-w-0 rounded-3xl border-2 border-accent/60 bg-navy px-5 py-7 text-center sm:p-9" data-id="element-141" data-mp="refwg4tbnz4w">
            <p className="font-display text-sm font-bold uppercase tracking-[0.22em] text-accent" data-id="element-142" data-mp="wc7z9tvi95nv">
              Your complete access today
            </p>
            <h2 id="offer-heading" className="mt-2 font-display text-[2.2rem] font-extrabold uppercase leading-[0.95] text-fg sm:text-5xl" data-id="element-143" data-mp="2y3ktnozujv5o">
              {brandName}
            </h2>
            <p className="mx-auto mt-3 max-w-sm leading-relaxed text-muted" data-id="element-144" data-mp="xx1vhp0nu41b">
              Everything included: 6 visual coaching volumes, 72 ready-to-run
              sessions and 5 coaching bonuses.
            </p>

            <div className="mt-5 rounded-3xl bg-panel p-3" data-id="element-145" data-mp="owwtjue8jxuj">
              <img src={optimizedImage(heroImage, 720)} srcSet={optimizedSrcSet(heroImage, [480, 720])} sizes="(min-width: 640px) 380px, 280px" alt="Everything included: 6 visual coaching volumes, the session-plan view and 5 coaching bonuses." className="mx-auto w-[280px] sm:w-[380px]" width={1240} height={1240} loading="lazy" decoding="async" data-id="element-146" data-mp="1lme52pzwge45" />
            </div>

            <div className="mt-5 border-t border-line pt-5" data-id="element-147" data-mp="17m3b3e3amjer">
              <p className="text-muted" data-id="element-148" data-mp="16szoequncgq">
                Regular price{' '}
                <span className="font-semibold text-fg/80 line-through decoration-danger decoration-2" data-id="element-149" data-mp="3scu5o8vyjfvi">{regularPrice}</span>
              </p>
              <p className="mt-3 font-display text-sm font-bold uppercase tracking-[0.22em] text-cta" data-id="element-150" data-mp="3tvavw8rhlmfb">
                Launch offer
              </p>
              <p className="mt-1 font-display text-[5.5rem] font-extrabold leading-none text-fg sm:text-[7rem]" data-id="element-151" data-mp="3ktbe3e8neebb">
                {price}
              </p>
              <p className="mt-2 font-display text-base font-bold uppercase tracking-[0.2em] text-accent" data-id="element-152" data-mp="3otlgkgx8emlf">
                One-time payment
              </p>
              <p className="mt-2 text-sm text-muted" data-id="element-153" data-mp="3ftyhw2vvzuw2">
                No subscription. Pay in your local currency where available.
              </p>
            </div>

            <div className="mt-5 rounded-2xl bg-accent/[0.07] px-4 py-3.5" data-id="element-154" data-mp="313936qj7vxng">
              <h3 className="font-display text-xs font-bold uppercase tracking-[0.22em] text-accent" data-id="element-155" data-mp="364ye866fwbbj">
                What you get
              </h3>
              <ul className="mt-2.5 grid grid-cols-2 gap-x-3 gap-y-1 text-left" data-id="element-156" data-mp="2x3h3727w2ztp">
                {included.map(item => <li key={item} className="flex items-start gap-1.5 text-[0.75rem] font-medium leading-snug text-fg sm:text-[0.8rem]" data-id="element-157" data-mp="2dhp0zml4qsii">
                    <CheckIcon className="mt-[0.2rem] h-3 w-3 shrink-0 text-accent" strokeWidth={3} aria-hidden="true" data-id="element-158" data-mp="28k5igaheftkr" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <CtaButton size="large" className="mt-5 w-full" data-id="element-159" data-mp="2ifgps7qh9yih">
              Get full access now — {price}
            </CtaButton>

            <p className="mt-4 text-sm text-muted" data-id="element-160" data-mp="2wegetghwkff6">
              Secure payment · Instant access · 7-day guarantee
            </p>
          </div>
        </div>
      </div>
    </section>;
}